export const AMOUNT_TYPE_SINGLE = "single";
export const AMOUNT_TYPE_MULTIPLE = "multiple";

export const EXPIRATION_TYPE_DAYS = "days";
export const EXPIRATION_TYPE_DATE = "date";